import { mapState } from 'vuex'
import store from '@/store'

// 收集 Vuex state 中的所有键名
let $uStoreKey = []
try {
	$uStoreKey = store.state ? Object.keys(store.state) : []
} catch (e) {
	console.error('获取 Vuex state 失败：', e)
}

// 改用 ESM 的 export default 导出（核心修正）
export default {
	created() {
		// 挂载 $u.vuex 方法，用于修改 Vuex 状态
		// 使用示例：this.$u.vuex('user.name', '新名称')
		this.$u = this.$u || {} // 确保 $u 对象存在
		this.$u.vuex = (name, value) => {
			store.commit('$uStore', {
				name,
				value
			})
		}
	},
	computed: {
		// 将 Vuex state 中的所有变量映射到组件（通过计算属性）
		...mapState($uStoreKey)
	}
}
